export const LITTER_TITLE_PATTERN = "\\b(puppies|litter)\\b";

export function isLitterTitle(name: string | null | undefined): boolean {
    if (!name) return false;
    return new RegExp(LITTER_TITLE_PATTERN, "iu").test(name);
}

export function withoutLitterListings<
    T extends { name?: string | null; litter?: boolean },
>(listings: T[]): T[] {
    return listings.filter(
        (listing) => listing.litter !== true && !isLitterTitle(listing.name),
    );
}
